const TIMEOUT_EXPIRATION = 4000;
const ANIMATION_DURATION = 200;

export { TIMEOUT_EXPIRATION, ANIMATION_DURATION };
